import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './pages/auth/login/login.component';
import { RegisterComponent } from './pages/auth/register/register.component';
import { ContactComponent } from './pages/contact/contact.component';
import { Error404Component } from './pages/error/error404/error404.component';
import { HomeComponent } from './pages/home/home.component';
import { AuthGuard } from './services/auth/auth.guard';
import { CreateProfileComponent } from './pages/create-profile/create-profile.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'create-profile', component: CreateProfileComponent, canActivate: [AuthGuard] },
  {path: 'register', component: RegisterComponent },
  {path: 'contact', component: ContactComponent },
  {path: 'logout', component: ContactComponent, canActivate: [AuthGuard] },
  // {path: '', component: HomeComponent, canActivate: [AuthGuard] },
  {path: '', component: HomeComponent, canActivate: [AuthGuard]},
  {path: '404', component: Error404Component },
  {path: '**', redirectTo: '/404' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

export const routingComponent = [HomeComponent, LoginComponent, RegisterComponent, Error404Component, ContactComponent, CreateProfileComponent];
